import { CountryCode } from 'libphonenumber-js/types';

export const POPULAR_COUNTRY_CODES: CountryCode[] = [
  'US',
  'CA',
  'MX',
  'GB',
  'AU',
  'RU',
  'CH',
  'HK',
  'JP',
  'IN',
  'BR',
];

export const SCHEMA_METHOD_NAME = 'phoneNumberFormat';

export const DEFAULT_COUNTRY_CODE: CountryCode = 'US';
